import isPropValidEmotion from '@emotion/is-prop-valid';

const STANDARDIZED_PROPS = ['fetchpriority', 'fetchPriority'];

const isPropValid = (prop: string) => isPropValidEmotion(prop) || STANDARDIZED_PROPS.includes(prop);

export const getForwardPropOpts = (propsToFilter: string[] = [], respectValidity = true) => ({
  shouldForwardProp: (currentProp: string) => {
    const isPropFound = propsToFilter.includes(currentProp);

    return respectValidity ? isPropValid(currentProp) && !isPropFound : !isPropFound;
  },
});
